import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { findByProfessores } from "../TDP/api-tdp";
import MenuItem from '@mui/material/MenuItem';
import { findByUsuarioCodigo, findByCurrentUser, sendEmailPresencaAtradas } from "./api-acompanhamento";
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import CircularProgress from '@mui/material/CircularProgress';
import { dateFormat } from '../../util/DateUtil';
import Button from '@mui/material/Button';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    title: {
        marginBottom: '20px'
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 120,
    },
    rowHeader: {
        backgroundColor: '#b284d2',
        color: 'white',
        fontSize: 13,
        fontWeight: '700',
        textAlign: 'center',
    },
    row: {
        textAlign: 'center',
    }
});

export default function AcompanhamentoContainer() {
    const classes = useStyles();
    const [acompanhamentos, setAcompanhamnetos] = useState([]);
    const usuario = useSelector(state => state.usuario);
    const [professores, setProfessores] = useState([]);
    const [codProfessorSelected, setCodProfessorSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (usuario && (usuario.perfil === 'ADMIN' || usuario.perfil === 'COORDENADOR')) {
            findByProfessores().then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setProfessores(data);
                }
            });
        } else if (usuario && usuario.perfil === 'PROFESSOR') {
            setIsLoading(true);
            findByCurrentUser().then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setAcompanhamnetos(data);
                    setIsLoading(false);
                }
            })
        }
    }, [usuario]);

    useEffect(() => {
        if (codProfessorSelected) {
            setIsLoading(true);
            findByUsuarioCodigo(codProfessorSelected).then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setAcompanhamnetos(data);
                    setIsLoading(false);
                }
            })
        }

    }, [codProfessorSelected]);

    const handleProfessorSelected = (event) => {
        setCodProfessorSelected(event.target.value);
    };

    const handleEnviarEmailPresencaAtrasadas = () => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja enviar os e-mails de notificação?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        sendEmailPresencaAtradas().then((data) => {
                            if (data.error) {
                                console.log(data.error);
                            }
                        });
                        toast.success("E-mails de Notificação estão sendo enviados.", {
                            position: "bottom-left"
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    }

    return (
        <Container className={classes.paper} maxWidth={'xl'} component={Paper}>

            <Grid container spacing={3}>
                <Grid size={12}>
                    <Grid container direction='row' justifyContent="space-between">
                        <Grid size={3}>
                            <Typography className={classes.title} variant="h6">
                                Acompanhamento
                            </Typography>
                        </Grid>
                        <Grid size={3}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleEnviarEmailPresencaAtrasadas}
                            >
                                Enviar E-mail Presenças Atrasadas
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    {usuario && (usuario.perfil === 'ADMIN' || usuario.perfil === 'COORDENADOR') ?
                        <>
                            <FormControl
                                sx={{ m: 1, minWidth: 300 }}
                            >
                                <InputLabel
                                    id="demo-simple-select-label">
                                    Professor(a)
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={codProfessorSelected ? codProfessorSelected : ''}
                                    onChange={handleProfessorSelected}
                                >
                                    {professores.map((professor) => (
                                        <MenuItem
                                            key={professor.id}
                                            value={professor.id}
                                        >
                                            {professor.nome}
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </>

                        : ''
                    }
                </Grid>
                <Grid size={12}>
                    {codProfessorSelected || (usuario && usuario.perfil === 'PROFESSOR') ?

                        <>
                            {isLoading ?
                                <div className={classes.loading}>
                                    <CircularProgress color="primary" />
                                    Carregando...
                                </div>
                                :
                                <div style={{ paddingTop: '32px' }}>
                                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2} className={classes.rowHeader}>Turma - Disciplina</TableCell>
                                                <TableCell rowSpan={2} className={classes.rowHeader}>Data Últ. Presença</TableCell>
                                                <TableCell rowSpan={2} className={classes.rowHeader}>Data Últ. Atividade</TableCell>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderRight: 'solid black',
                                                    borderLeft: 'solid black',
                                                }} colSpan={4} className={classes.rowHeader}>Quantidade Presenças - (Quant. Aulas/Quant. Aulas Registradas)</TableCell>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderRight: 'solid black',
                                                    borderLeft: 'solid black',
                                                }} colSpan={4} className={classes.rowHeader}>Quantidade Atividades</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderLeft: 'solid black',
                                                }} className={classes.rowHeader}>1º Bimestre</TableCell>
                                                <TableCell className={classes.rowHeader}>2º Bimestre</TableCell>
                                                <TableCell className={classes.rowHeader}>3º Bimestre</TableCell>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderRight: 'solid black',
                                                }} className={classes.rowHeader}>4º Bimestre</TableCell>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderLeft: 'solid black',
                                                }} className={classes.rowHeader}>1º Bimestre</TableCell>
                                                <TableCell className={classes.rowHeader}>2º Bimestre</TableCell>
                                                <TableCell className={classes.rowHeader}>3º Bimestre</TableCell>
                                                <TableCell style={{
                                                    borderBottom: 0,
                                                    borderRight: 'solid black',
                                                }} className={classes.rowHeader}>4º Bimestre</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {acompanhamentos.map((acompanhamento, index) => (
                                                <TableRow key={index}>
                                                    <TableCell className={classes.row}>{acompanhamento.tdp.turma.descricao} - {acompanhamento.tdp.disciplina.descricao}</TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.dataUltPresenca ? dateFormat(acompanhamento.dataUltPresenca) : '--'}</TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.dataUltAtividade ? dateFormat(acompanhamento.dataUltAtividade) : '--'}</TableCell>
                                                    <TableCell className={classes.row}>
                                                        <Grid container spacing={1} direction='column'>
                                                            <Grid>
                                                                {acompanhamento.quantAula1}/{acompanhamento.quantPresenca1}
                                                            </Grid>
                                                            <Grid>
                                                                <Link
                                                                    to={{
                                                                        pathname: "/conferir-cronograma-presenca",

                                                                    }}
                                                                    state={{
                                                                        tdp: acompanhamento.tdp,
                                                                        numeroBimestre: 1
                                                                    }}
                                                                >
                                                                    Conferir
                                                                </Link>
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell className={classes.row}>
                                                        <Grid container spacing={1} direction='column'>
                                                            <Grid >
                                                                {acompanhamento.quantAula2}/{acompanhamento.quantPresenca2}
                                                            </Grid>
                                                            <Grid>
                                                                <Link
                                                                    to={{
                                                                        pathname: "conferir-cronograma-presenca",
                                                                        state: {
                                                                            tdp: acompanhamento.tdp,
                                                                            numeroBimestre: 2
                                                                        }
                                                                    }}
                                                                >
                                                                    Conferir
                                                                </Link>
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell className={classes.row}>
                                                        <Grid container spacing={1} direction='column'>
                                                            <Grid >
                                                                {acompanhamento.quantAula3}/{acompanhamento.quantPresenca3}
                                                            </Grid>
                                                            <Grid >
                                                                <Link
                                                                    to={{
                                                                        pathname: "conferir-cronograma-presenca",
                                                                        state: {
                                                                            tdp: acompanhamento.tdp,
                                                                            numeroBimestre: 3
                                                                        }
                                                                    }}
                                                                >
                                                                    Conferir
                                                                </Link>
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell className={classes.row}>
                                                        <Grid container spacing={1} direction='column'>
                                                            <Grid >
                                                                {acompanhamento.quantAula4}/{acompanhamento.quantPresenca4}
                                                            </Grid>
                                                            <Grid >
                                                                <Link
                                                                    to={{
                                                                        pathname: "conferir-cronograma-presenca",
                                                                        state: {
                                                                            tdp: acompanhamento.tdp,
                                                                            numeroBimestre: 4
                                                                        }
                                                                    }}
                                                                >
                                                                    Conferir
                                                                </Link>
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.quantAtividade1}</TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.quantAtividade2}</TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.quantAtividade3}</TableCell>
                                                    <TableCell className={classes.row}>{acompanhamento.quantAtividade4}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>

                            }
                        </>
                        : ''
                    }
                </Grid>
            </Grid>







        </Container>
    );
}